jQuery(document).ready(function(){
  // dynamically populate product form with sku and title
  
  jQuery("#order-form-btn").click(function(){
      console.log("click");
      var product_title = jQuery(".product__information .product_name").text().trim();
      console.log(product_title);

      var product_sku = jQuery(".custom_sku").text().trim();
      console.log(product_sku);

      jQuery(".sjfb-field").each(function(){
          var field_check = jQuery(this).find("label").text();
          var field_class = field_check.replace(" ", "_");
          field_class = field_class.replace("/", "_");
          jQuery(this).addClass(field_class);
          var $this = jQuery(this).find("label");
          
          //console.log(field_check);
          if (field_check == "Product Name"){
              jQuery($this).siblings("input").val(product_title);
          }
          else if(field_check == "SKU"){
              jQuery($this).siblings("input").val(product_sku);

          }
      })
  });
      
  
  
  jQuery(".collection_nav__select").on("click", function(){
  	jQuery(this).toggleClass("active");
  });
  
  /*
  if(jQuery(".product-column-row").hasClass("product_hidden")){
	jQuery(".home_main_s_link").hide();
  }else{
	  jQuery(".home-shop-all").hide();
	  jQuery(".home_main_s_link").show();
  }
  */
  jQuery(".home-shop-all").on("click", function(){
	jQuery(".product_hidden").addClass("product_revealed");
	jQuery(".product_revealed").removeClass("product_hidden");
	jQuery(this).hide();
	//jQuery(".home_main_s_link").show();
  });
  
});



// On call to IPGeolocation API on each page during a user's visit, API response will be served from sessionStorage after the first page.
_ipgeolocation.enableSessionStorage(true);

var ip = sessionStorage.getItem("ip");
var country_name = sessionStorage.getItem("country_name");
var country_code2 = sessionStorage.getItem("country_code2");

if (!ip || !country_name || !country_code2) {
  _ipgeolocation.makeAsyncCallsToAPI(false);
  _ipgeolocation.setFields("country_name,country_code2");
  _ipgeolocation.getGeolocation(handleResponse, "b54f5dc84c7a481a98a7d50b5d3b5c78");
}

function handleResponse(json) {
  ip = json.ip;
  country_name = json.country_name;
  country_code2 = json.country_code2;
}

if (country_name != 'United States') {
  jQuery("a#order-form-btn").css("display", "inline-block");
  jQuery(".product-form-container").css("display", "none");
}

/* Cart Page Checkout Button Loading */
jQuery(document).ready(function(){
  jQuery( ".cart__checkout button#checkout" ).click(function() {
    jQuery('.cart__checkout button#checkout').html('<i class="fas fa-spinner fa-pulse"></i>&nbsp;Processing Your Cart');
  });
});
